import { ExalusInstallationCredentials } from '../types/exalus';

const KEY = 'EXALUS_DATA_STORAGE';

export type ExalusStorageType = {
  installationsCredentials: ExalusInstallationCredentials[];
  updateControllerMemory: Record<string, Date>;
  updateDevicesMemory: Record<string, Date>;
  remindCreateAccount: Date | null;
};

// It should never have happened
if (!window) {
  console.error('Window Local Storage Missing.  No data will be stored locally.');
}

export const defaultState: ExalusStorageType = {
  installationsCredentials: [],
  updateControllerMemory: {},
  updateDevicesMemory: {},
  remindCreateAccount: null,
};

let data: ExalusStorageType = { ...defaultState };

const dataString = window.localStorage.getItem(KEY);

if (dataString) {
  try {
    const parsedData: ExalusStorageType = JSON.parse(dataString);
    if (parsedData) {
      data = parsedData;
    }
  } catch {
    console.error(`LocalStorage value of key: "${KEY}" is not a valid JSON.`);
    // Temporary option of clearing cache on error
    window.localStorage.removeItem(KEY);
    data = defaultState;
  }
}

export const getItem = <Key extends keyof ExalusStorageType>(key: Key): ExalusStorageType[Key] => {
  return data[key];
};

export const setItem = <Key extends keyof ExalusStorageType>(key: Key, value: ExalusStorageType[Key]) => {
  data[key] = value;
  window.localStorage.setItem(KEY, JSON.stringify(data));
};

export const clearOneCredentials = (installationId?: string) => {
  const installationsCredentials = getItem('installationsCredentials') || [];

  const deletedIndex = installationsCredentials.findIndex((x) => x.id === installationId);
  if (deletedIndex !== -1) {
    installationsCredentials.splice(deletedIndex, 1);
    window.localStorage.setItem(KEY, JSON.stringify({ ...defaultState, installationsCredentials }));
  }
};
